import {
  Chart,
  PointElement,
  LineElement,
  TimeScale,
  Colors,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import _ from 'lodash';
import { Line } from 'react-chartjs-2';
import React from 'react';
import 'chartjs-adapter-moment';

Chart.register(PointElement, LineElement, TimeScale, Colors, Legend, Filler, Tooltip);

const SimpleStackedChart = ({
  datasets = [],
  height = '350px',
  title,
  unit = 'month',
  stacked = true,
  fill = true,
  ticks,
  override,
}) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 0,
    },
    plugins: {
      colors: {
        enabled: true,
      },
      title: {
        display: !!title,
        text: title,
      },
      legend: {
        display: datasets.length > 1,
      },
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false,
    },
    scales: {
      y: {
        beginAtZero: true,
        stacked,
        ticks,
      },
      x: {
        type: 'time',
        time: { unit },
      },
    },
  };

  _.merge(options, override ?? {});

  const data = {
    datasets: datasets.map((d) => {
      return {
        label: d.label,
        data: d.values,
        fill,
      };
    }),
  };

  return (
    <div className="chart" style={{ height }}>
      <Line data={data} options={options} />
    </div>
  );
};

export default SimpleStackedChart;
